import { render } from "./UndetectedAreaJa.vue?vue&type=template&id=59492dba"
import script from "./UndetectedAreaJa.vue?vue&type=script&lang=js"
export * from "./UndetectedAreaJa.vue?vue&type=script&lang=js"

import "./UndetectedAreaJa.vue?vue&type=style&index=0&id=59492dba&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__